export const hasOwn: Function = Object.prototype.hasOwnProperty;



/** WEBPACK FOOTER **
 ** ./src/helper/has-own.ts
 **/